module.exports = __webpack_public_path__ + "img/trojan.b4ac34d3.jpg";